import http from '../utils/http';

import {
  GET_REPORT_TEMPLATES,
} from '../constants/actionTypes';

import { setFeedbackAction } from './feedback';

import {
  reportTemplatesUrl,
  generateReportUrl,
} from '../constants/urls';

const getReportTemplatesAction = templates => ({ type: GET_REPORT_TEMPLATES, payload: templates })

export const getReportTemplates = jobId =>
  async dispatch => {
    try {
      const { data: response } = await http.get(reportTemplatesUrl(jobId))
      const reportTemplates = response.data.reduce((acc, template) => {
        return [...acc, { value: template, label: template }]
      }, [])

      dispatch(getReportTemplatesAction(reportTemplates))
    } catch (e) {
      dispatch(setFeedbackAction(e.message))
    }
  }

export const generateReport = (jobId, template, description, format) =>
  async dispatch => {
    try {
      const response = await http.getFile(generateReportUrl(jobId, template, description, format));
      const fileName = response.headers['content-disposition'].split('"')[1];
      const file = new Blob([response.data]);

      const reportLink = document.querySelector('#download');
      reportLink.href = URL.createObjectURL(file);
      reportLink.setAttribute('download', fileName);
      reportLink.click();
      reportLink.href = "";
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }



// WEBPACK FOOTER //
// ./src/actions/reports.js